// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__L_ah0","image":"Header_image__xSaZp","name":"Header_name__3v7Ea","info":"Header_info__2QGkI","infoRow":"Header_infoRow__7kp6Y"};